import { withAlertHandler } from 'entoro-shared';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import OfferPwdDialog from './OfferPwdDialog';
import IconButton from 'material-ui/IconButton';
import SvgIcon from 'material-ui/SvgIcon';
import { Link } from 'react-router-dom';
import { CRYPTO_COMPARE_KEY } from '../../../config';

class OfferPwdAction extends Component {
  request = async (variables) => {
    const {
      client,
      handleSnackbarError,
      setSnackbarMessage,
      mutation,
    } = this.props;
    const { mutate } = client;

    const input = {
      ...variables,
    };
    try {
      const {
        data: { validateOfferPassword: result },
      } = await mutate({ mutation, variables: { input } });

      if (result === true) {
        localStorage.setItem(
          `${localStorage.getItem('authToken')}${CRYPTO_COMPARE_KEY.concat(
            input.offerId
          )}`,
          `${localStorage
            .getItem('authToken')
            .concat(input.offerId)}${CRYPTO_COMPARE_KEY}`
        ); //Set offerpasswordpersistance to localstorage
        setSnackbarMessage('Offer Password is correct');
        this.props.handleChangeOfferPassStatus();
      } else {
        setSnackbarMessage('Oops!! Offer Password is incorrect.');
      }
    } catch (error) {
      handleSnackbarError(error);
    }
  };

  render() {
    const {
      title,
      disabled,
      open,
      handleClickOpen,
      handleClose,
      offerId,
      handleChangeOfferPassStatus,
      isAuthenticated,
    } = this.props;

    return (
      <Fragment>
        <OfferPwdDialog
          open={open}
          disabled={disabled}
          handleClose={handleClose}
          request={this.request}
          handleChangeOfferPassStatus={handleChangeOfferPassStatus}
          title='Private Offering'
          offerId={offerId}
        />
        <IconButton aria-label='lock'>
          <SvgIcon style={{ fontSize: 30 }}>
            <path d='M17.308,7.564h-1.993c0-2.929-2.385-5.314-5.314-5.314S4.686,4.635,4.686,7.564H2.693c-0.244,0-0.443,0.2-0.443,0.443v9.3c0,0.243,0.199,0.442,0.443,0.442h14.615c0.243,0,0.442-0.199,0.442-0.442v-9.3C17.75,7.764,17.551,7.564,17.308,7.564 M10,3.136c2.442,0,4.43,1.986,4.43,4.428H5.571C5.571,5.122,7.558,3.136,10,3.136 M16.865,16.864H3.136V8.45h13.729V16.864z M10,10.664c-0.854,0-1.55,0.696-1.55,1.551c0,0.699,0.467,1.292,1.107,1.485v0.95c0,0.243,0.2,0.442,0.443,0.442s0.443-0.199,0.443-0.442V13.7c0.64-0.193,1.106-0.786,1.106-1.485C11.55,11.36,10.854,10.664,10,10.664 M10,12.878c-0.366,0-0.664-0.298-0.664-0.663c0-0.366,0.298-0.665,0.664-0.665c0.365,0,0.664,0.299,0.664,0.665C10.664,12.58,10.365,12.878,10,12.878' />
          </SvgIcon>
        </IconButton>
        {isAuthenticated ? (
          <button
            onClick={handleClickOpen}
            className='button w-button'
            style={{ width: 'inherit' }}
          >
            {title}
          </button>
        ) : (
          <Link
            // eslint-disable-next-line no-underscore-dangle
            to='/login'
            className='button w-button'
            style={{ width: 'inherit' }}
          >
            Private Offering
          </Link>
        )}
      </Fragment>
    );
  }
}

OfferPwdAction.propTypes = {
  client: PropTypes.object.isRequired,
  handleSnackbarError: PropTypes.func.isRequired,
  setSnackbarMessage: PropTypes.func.isRequired,
  mutation: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  offerId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  handleChangeOfferPassStatus: PropTypes.func,
  open: PropTypes.bool.isRequired,
  handleClickOpen: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
};

OfferPwdAction.defaultProps = {
  disabled: false,
};

export default connect()(withApollo(withAlertHandler(OfferPwdAction)));



// WEBPACK FOOTER //
// ./src/components/Dashboard/OfferPwd/OfferPwdAction.js